<template>
  <div>
    <hr />

    <div class="input-group my-3">
      <table class="table table-striped">
        <tbody>
          <tr>
            <td class="text-start col-50">
              <label for="cargaSeleccionada"><b>Seleccione un periodo:</b></label>
            </td>
            <td>
              <select
                id="cargaSeleccionada"
				name="cargaSeleccionada"
                v-model="cargaSeleccionada"
                class="form-select"
                @change="handleSelection"
              >
                <option
                  v-for="carga in cargas"
                  :key="carga.idCarga"
                  :value="carga.idCarga"
                >
                  {{ getFormattedDate(carga.fechaDesde) }} -
                  {{ getFormattedDate(carga.fechaHasta) }} -
                  {{ carga.tipoCarga === 'M' ? 'Mensual' : carga.tipoCarga === 'S' ? 'Semanal' : carga.tipoCarga === 'A' ? 'Autorización' : carga.tipoCarga }}
                </option>
              </select>
            </td>
            <td class="text-end w-50">
              <button @click="exportarCSV" class="btn btn-success">
                Exportar a CSV
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-if="planillas.length > 0">
      <table class="table table-striped">
        <thead>
          <tr>
            <th>ID Planilla</th>
            <th>Número</th>
            <th>Cédula</th>
            <th>Nombre</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="planilla in planillas" :key="planilla.idPlanilla">
            <td>{{ planilla.idPlanilla }}</td>
            <td>{{ planilla.numero }}</td>
            <td>{{ planilla.cedula }}</td>
            <td>{{ planilla.nombre }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <p v-else class="text-center text-muted">No hay atenciones sin archivos.</p>
  </div>
</template>

<script>

import api from "@/services/api";
import dateFormat from "@/modules/dateFormat.js";

export default {
  data() {
    return {
      p_idTramite: null, // Se asignará en mounted()
      planillas: [],
      cargas: [],
      cargaSeleccionada: null,
    };
  },
  mounted() {
    // Obtener ID del trámite desde la ruta
    this.p_idTramite = this.$route.params.p_idtramite;

    // Si el parámetro es válido, obtener automáticamente el reporte
    if (this.p_idTramite) {
      //        this.obtenerReporte();
    }
    this.fetchCargas();
  },
  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    async obtenerReporte() {
      try {
        const response = await api.get(`/vwplanillas/sin-archivos/${this.p_idTramite}/${this.cargaSeleccionada}`
        );
        this.planillas = response.data;
      } catch (error) {
        console.error("Error al obtener el reporte:", error);
        alert(
          "Error al obtener el reporte. Verifique la conexión con el servidor."
        );
      }
    },
    exportarCSV() {
      if (this.planillas.length === 0) {
        alert("No hay datos para exportar.");
        return;
      }

      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += "ID Planilla;Número;Cédula;Nombre\n";
      this.planillas.forEach((planilla) => {
        csvContent += `${planilla.idPlanilla};${planilla.numero};${planilla.cedula};${planilla.nombre}\n`;
      });

      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute(
        "download",
        `Reporte_Planillas_Sin_Archivos_${this.p_idTramite}.csv`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    async fetchCargas() {
      try {
        const response = await api.get("/vwcargas/activas-por-tramite/" +
            this.p_idTramite
        );
        this.cargas = response.data;
      } catch (error) {
        console.error("Error al obtener cargas:", error);
      }
    },
    formatFecha(fecha) {
      return fecha ? fecha.split("T")[0] : "";
    },
    handleSelection() {
      this.obtenerReporte();
    },
  },
};
</script>
